import "./App.scss";
import { Header, IntroSplash } from "./view/components/shared";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import BlogPage from "./view/Pages/BlogPage";
import TeamPage from "./view/Pages/TeamPage";
import StoryPage from "./view/Pages/StoryPage";
import ServicesPage from "./view/Pages/ServicesPage";
import Homer from "./view/Pages/Homer";
import ContactPage from "./view/Pages/ContactPage";
import CareerPage from "./view/Pages/CareerPage";
import ServiceDetailPage from "./view/Pages/ServiceDetailPage";
import CaseStudiesPage from "./view/Pages/CaseStudiesPage";
import ResourcesPage from "./view/Pages/ResourcesPage";
import "./App.scss";
import RecruitmentForm from "./view/Pages/RecruitmentForm";
import PrivacyPolicyPage from "./view/Pages/PrivacyPolicyPage";
import TermsPage from "./view/Pages/TermsPage";
import NotFoundPage from "./view/Pages/NotFoundPage";
import { createContext, useEffect, useLayoutEffect, useState } from "react";
import SingleBlog from "./view/components/LatestBlog/SingleBlog";
import { Toaster } from 'react-hot-toast';
import GlobalFloating from "./view/components/shared/GlobalFloating";
import { RegionProvider, useRegion } from "./regions/RegionContext";
import { trackPageView, setSiteRegion } from "./lib/gtag";

export const LangContext = createContext();

function AppShell({ children }) {
  const { region } = useRegion();
  useEffect(() => {
    setSiteRegion(region);
  }, [region]);
  return (
    <div className="App" data-region={region}>
      {children}
    </div>
  );
}

function App() {
  const [langEng, setLangEng] = useState(true);
  const Wrapper = ({ children }) => {
    const location = useLocation();
    useLayoutEffect(() => {
      document.documentElement.scrollTo(0, 0);
    }, [location.pathname]);
    useEffect(() => {
      trackPageView(location.pathname + location.search);
    }, [location.pathname, location.search]);
    return children;
  };

  return (
    <RegionProvider>
    <AppShell>
      <IntroSplash />
      <LangContext.Provider value={{ langEng, setLangEng }}>
        <BrowserRouter>
          <Wrapper>
            <GlobalFloating />
            <Routes>
              <Route exact path="/" element={<Homer />} />
              <Route exact path="/Contact" element={<ContactPage />} />
              <Route exact path="/Blogs" element={<BlogPage />} />
              <Route exact path="/Careers" element={<CareerPage />} />
              <Route exact path="/Team" element={<TeamPage />} />
              <Route exact path="/Ourstory" element={<StoryPage />} />
              <Route exact path="/Services" element={<ServicesPage />} />
              <Route exact path="/CaseStudies" element={<CaseStudiesPage />} />
              <Route exact path="/Resources" element={<ResourcesPage />} />
              <Route path="/Blogs/:productId" element={<SingleBlog />} />

              <Route
                exact
                path="/Terces_Recruitment"
                element={<RecruitmentForm />}
              />
              {/* <Route
                path="/SingleService/:productId"
                element={<SingleService />}
              />
              <Route
                path="/SingleSolution/:productId"
                element={<SingleSolution />}
              /> */}
              <Route
                path="/services/:serviceId"
                element={<ServiceDetailPage />}
              />
              <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
              <Route path="/terms" element={<TermsPage />} />
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </Wrapper>
        </BrowserRouter>
      </LangContext.Provider>
       <Toaster />
    </AppShell>
    </RegionProvider>
  );
}

export default App;
